import { NavLink, ScrollArea, Stack, Text } from '@mantine/core';
import { IconShieldLock } from '@tabler/icons-react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { useAuthStore } from '../auth/auth-store';
import { useProjectStore } from '../project/project-store';
import { NAV_BY_APP } from '../app-shell/nav-config';

/** Matches an app root path like `/a/running-title` (no further segments) —
 *  the dashboard/index item for that app, which needs exact-match `end`
 *  routing so it isn't shown active for every sub-route. */
const APP_ROOT_RE = /^\/a\/[^/]+$/;

/** Admin isn't scoped to any one app — kept as a separate, superadmin-gated
 *  item, same as before per-app namespacing. */
const ADMIN_ITEM = {
  to: '/admin',
  label: 'Admin',
  icon: <IconShieldLock size={18} />,
};

export function SideNav() {
  const user = useAuthStore((s) => s.user);
  const projectId = useProjectStore((s) => s.projectId);
  const appKey = useProjectStore((s) => s.appKey);

  const items = NAV_BY_APP[appKey ?? 'running_title'] ?? [];
  const showAdmin = user?.system_role === 'superadmin';

  return (
    <ScrollArea h="100%" type="auto">
      <Stack gap={2} p="xs">
        {!projectId && (
          <Text size="xs" c="dimmed" px="sm" py="xs">
            Pick a project to start
          </Text>
        )}
        {items.map((item) =>
          item.comingSoon ? (
            <NavLink
              key={item.to}
              label={item.label}
              leftSection={<item.icon size={18} />}
              rightSection={
                <Text size="xs" c="dimmed">
                  soon
                </Text>
              }
              disabled
            />
          ) : (
            <NavLink
              key={item.to}
              label={item.label}
              leftSection={<item.icon size={18} />}
              component={RouterNavLink}
              to={item.to}
              end={APP_ROOT_RE.test(item.to)}
            />
          ),
        )}
        {showAdmin && (
          <NavLink
            key={ADMIN_ITEM.to}
            label={ADMIN_ITEM.label}
            leftSection={ADMIN_ITEM.icon}
            component={RouterNavLink}
            to={ADMIN_ITEM.to}
          />
        )}
      </Stack>
    </ScrollArea>
  );
}
